import { useQuery } from '@tanstack/react-query';
import { orders } from '@/utils/api';

export function useOrders(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['orders', params],
    queryFn: () => orders.getAll(params).then((r) => r.data),
  });
}

export function useOrder(id: number | string | undefined) {
  return useQuery({
    queryKey: ['orders', id],
    queryFn: () => orders.getById(id).then((r) => r.data),
    enabled: !!id,
  });
}
